class Video {
  constructor() {
    const playButton = Array.prototype.slice.call(document.querySelectorAll('.ns-video__thumbnail'));
    playButton.forEach(button => {
      button.addEventListener('click', () => {
        const video = button.parentElement.parentElement;
        const thumbnail = button.nextSibling;
        const videoContainer = video.querySelector('.ns-video');
        const link = button.parentElement.nextSibling;
        const iframe = video.querySelector('iframe');
        const videoElement = video.querySelector('video');
        if (iframe) {
          if (iframe.src.includes('?')) {
            iframe.src = iframe.src + '&autoplay=1';
          } else {
            iframe.src = iframe.src + '?autoplay=1';
          }
        } else if (videoElement) {
          videoElement.play();
        }
        button.style.display = 'none';
        thumbnail.style.display = 'none';
        videoContainer.style.display = 'block';
        if (link) {
          link.style.display = 'none';
        }
      });
    });
  }
} export default Video;


